import { RuleListStatus } from '@wix/rules-panel-ui';
import { groupBy } from 'lodash';
import { useCallback } from 'react';
import { useBuildCrossPagesRuleResult } from './use-build-cross-pages-rule-result';
import { useBuildSpecificPageIssueResults } from './use-build-specific-page-issue-results';
export const getGroupedExecutionResults = executionResults => {
  const groupedByPage = groupBy(executionResults, res => {
    var _res$metadata;
    return (_res$metadata = res.metadata) == null ? void 0 : _res$metadata.pageId;
  });
  return Object.fromEntries(Object.entries(groupedByPage).map(_ref => {
    let [pageId, groupItems] = _ref;
    return [pageId, groupBy(groupItems, _ref2 => {
      let {
        ruleId
      } = _ref2;
      return ruleId;
    })];
  }));
};
export const getIsAllCrossPageIssuePassed = crossPagesRuleResult => {
  return crossPagesRuleResult.every(result => (result == null ? void 0 : result.status) === RuleListStatus.passed);
};
export const useGetItemTypeEntitiesSummaryAfterCrossPageCalculation = () => {
  const crossPagesRuleResultBuilder = useBuildCrossPagesRuleResult();
  const specificPageIssueResultsBuilder = useBuildSpecificPageIssueResults();
  return useCallback((executionResults, tpaPageId) => {
    const pageIdToStateMap = new Map();
    const groupedExecutionResults = getGroupedExecutionResults(executionResults);
    const {
      crossPagesRuleResult,
      crossPagesIssues
    } = crossPagesRuleResultBuilder({
      executionResults: groupedExecutionResults,
      pageId: tpaPageId
    });
    const specificPageIssueResults = specificPageIssueResultsBuilder({
      crossPageIssues: crossPagesIssues,
      executionResults: groupedExecutionResults,
      pageId: tpaPageId
    });
    const tpaPageRuleIdToStatusMap = new Map(crossPagesRuleResult.map(result => [result.ruleId, {
      ruleId: result.ruleId,
      state: {
        status: result.status
      }
    }]));
    pageIdToStateMap.set(tpaPageId, tpaPageRuleIdToStatusMap);
    const specificPageResultGroupedByPage = groupBy(specificPageIssueResults, result => {
      var _result$metadata;
      return (_result$metadata = result.metadata) == null ? void 0 : _result$metadata.pageId;
    });
    Object.entries(specificPageResultGroupedByPage).forEach(_ref3 => {
      let [pageId, results] = _ref3;
      const resultsGroupedByRuleId = groupBy(results, result => result.ruleId);
      const ruleIdToStatusMap = new Map();
      Object.entries(resultsGroupedByRuleId).forEach(_ref4 => {
        let [ruleId, ruleResults] = _ref4;
        const hasFailed = ruleResults.some(result => {
          var _result$result;
          return ((_result$result = result.result) == null ? void 0 : _result$result.status) === 'failed';
        });
        const status = hasFailed ? RuleListStatus.failed : RuleListStatus.passed;
        if (status) {
          ruleIdToStatusMap.set(ruleId, {
            ruleId: ruleId,
            state: {
              status
            }
          });
        }
      });
      pageIdToStateMap.set(pageId, ruleIdToStatusMap);
    });
    return pageIdToStateMap;
  }, [crossPagesRuleResultBuilder, specificPageIssueResultsBuilder]);
};
//# sourceMappingURL=use-get-entity-summary-after-cross-page-calculation.js.map